import axios from "axios";
import { useLoading } from "../../context/LoadingContext";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { useContext, useState } from "react";
import { toast } from "react-toastify";

// Create a custom hook for axios with token refresh
const useAxios = () => {
  const { startLoading, stopLoading } = useLoading();
  const { login, user } = useContext(AuthContext); // Getting the login function and user context
  const navigate = useNavigate();

  // Fetch the token if expired
  const fetchToken = async () => {
    const storedUser = JSON.parse(localStorage.getItem("user")); // or any state where user data is stored
    if (storedUser) {
      // console.log(storedUser, "storedUser");
      const {
        UserName,
        PracticeID,
        // AuthToken,
        DefaultTimeZoneOffSet,
        userId,
        practiceFullId,
      } = storedUser;

      const requestBody = { UserName, PracticeID };
      try {
        const data = await axios(
          `${process.env.REACT_APP_LOGIN_API_URL}/authentication/GetAuthToken?sInputJSON=${JSON.stringify(requestBody)}`,
          {
            // headers: { Authorization: `Bearer ${sAuthToken}` },
            method: "GET",
          },
        );
        // console.log(data);

        // Update user state with new token
        const newData = {
          ...data?.data,
          DefaultTimeZoneOffSet,
          userId,
          practiceFullId,
        };
        login(JSON.stringify(newData)); // Store the new token in the context and localStorage

        return data.AuthToken; // Return the new auth token
      } catch (error) {
        // toast.error("Failed to refresh token. Please login again.", {
        //   autoClose: 3000,
        // });
        navigate("/login"); // Redirect to login if refreshing token fails
      }
    }
    return null;
  };

  // Axios request method with token refresh logic
  const request = async (url, options = {}) => {
    startLoading();

    // Intercept axios request to attach auth token
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const authToken = storedUser ? storedUser.AuthToken : null;

    if (authToken) {
      // Attach auth token to request if exists
      options.headers = options.headers || {};
      options.headers["Authorization"] = `Bearer ${authToken}`;
    }

    try {
      const response = await axios(url, options);
      return response.data; // Return response data
    } catch (error) {
      if (error.response && error.response.status === 401) {
        const newToken = await fetchToken();

        if (newToken) {
          // Retry the original request with the new token
          options.headers["Authorization"] = `Bearer ${newToken}`;
          // const retryResponse = await axios(url, options);
          // return retryResponse.data;
        }
      }
      // toast.error("Request failed. Please try again.", { autoClose: 3000 });
      // throw error;
    } finally {
      stopLoading();
    }
  };

  return { request };
};

export default useAxios;
